export default (chartCardsArray) => {
    let slides = [];
    let end = 4;
    let slideNumber = 0;
    for(let i=0; i < chartCardsArray.length; i++) {
      if(slides[slideNumber] === undefined) {
        slides[slideNumber] = [];
      }
      if(i < end) {
        slides[slideNumber].push(chartCardsArray[i]);
      } else if(i === end) {
        slideNumber += 1;
        slides[slideNumber] = [];
        slides[slideNumber].push(chartCardsArray[i]);
        end += 4;
      }
    }
    return slides;
  }


// WEBPACK FOOTER //
// ./src/components/slideshow/Slideshow/buildSlides.js